module.exports = __webpack_public_path__ + "static/media/yoga-retreat-banner-desktop.fe1f38f4.webp";